import { Link } from 'react-router-dom';

const newsItems = [
  {
    id: 1,
    date: '2026.04.21',
    category: '会社情報',
    categoryColor: 'bg-emerald-100 text-emerald-700',
    title: '代表者変更に伴う会社情報更新のお知らせ',
    excerpt: '代表者変更に伴い、当社サイト上の会社情報を更新いたしました。今後ともよろしくお願いいたします。',
    isImportant: true,
  },
  {
    id: 2,
    date: '2026.03.15',
    category: 'サービス',
    categoryColor: 'bg-cyan-100 text-cyan-700',
    title: 'Webサービス運営プランをリニューアルしました',
    excerpt: 'お客様のニーズに合わせた新しい料金プランをご用意しました。詳細はサービスページをご覧ください。',
    isImportant: false,
  },
  {
    id: 3,
    date: '2026.02.28',
    category: 'お知らせ',
    categoryColor: 'bg-teal-100 text-teal-700',
    title: '株式会社Ocean 公式サイトをオープンしました',
    excerpt: '株式会社Oceanの公式コーポレートサイトをオープンいたしました。今後ともよろしくお願いいたします。',
    isImportant: false,
  },
  {
    id: 4,
    date: '2026.02.10',
    category: 'サービス',
    categoryColor: 'bg-cyan-100 text-cyan-700',
    title: 'アプリ開発サービスの提供を開始しました',
    excerpt: 'iOS・Android対応のネイティブアプリ開発サービスを正式に開始いたしました。',
    isImportant: false,
  },
];

export default function NewsSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <p className="text-teal-500 text-xs font-semibold uppercase tracking-widest mb-2">Latest News</p>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              ニュース・お知らせ
            </h2>
          </div>
          <Link
            to="/news"
            className="text-teal-600 text-sm font-medium flex items-center gap-1 cursor-pointer hover:gap-2 transition-all whitespace-nowrap"
          >
            すべて見る
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {newsItems.map((item) => (
            <Link
              key={item.id}
              to="/news"
              className={`group block p-5 rounded-xl border cursor-pointer transition-all hover:border-teal-300 ${
                item.isImportant
                  ? 'border-teal-300 bg-teal-50/50'
                  : 'border-gray-100 bg-white hover:bg-teal-50/30'
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="text-gray-400 text-xs">{item.date}</span>
                <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${item.categoryColor}`}>
                  {item.category}
                </span>
                {item.isImportant && (
                  <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-red-100 text-red-600">
                    重要
                  </span>
                )}
              </div>
              <h3 className="text-sm font-semibold text-gray-800 mb-1.5 group-hover:text-teal-700 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-gray-500 leading-relaxed line-clamp-2">{item.excerpt}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
